function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.945 86.5a2.225 2.225 0 0 0-2.452.5l-4.286 4.355V88.7a3.4 3.4 0 0 0-3.37-3.423H3.37A3.4 3.4 0 0 0 0 88.7v12.6a3.4 3.4 0 0 0 3.37 3.423h18.466a3.4 3.4 0 0 0 3.37-3.423v-2.659L29.492 103a2.221 2.221 0 0 0 2.452.5 2.287 2.287 0 0 0 1.389-2.112V88.613a2.286 2.286 0 0 0-1.388-2.113zm-16.108 9.383l-4.593 3.585a1.086 1.086 0 0 1-1.157.116 1.12 1.12 0 0 1-.614-1v-7.17a1.119 1.119 0 0 1 .614-1 1.086 1.086 0 0 1 1.157.116l4.593 3.585a1.129 1.129 0 0 1 0 1.774z",
  transform: "translate(8.333 -69.995)"
});

function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.f249e3a6.svg";
export { ForwardRef as ReactComponent };